import {
  EmailRequest,
  EmailResponse,
  VerificationCodeRequest,
  VerificationCodeResponse,
} from "@/modules/user/types/user";
import { authRefreshApi } from "../authApi";
import { useToasterStore } from "../../store/toaster";
import { AxiosError } from "axios";

export const postAuthEmail = async (
  payload: EmailRequest
): Promise<EmailResponse | undefined> => {
  try {
    const response = await authRefreshApi.post("/auth/email", payload);

    const answer = response.data as EmailResponse;

    return answer;
  } catch (err: unknown) {
    let message = "Unknown error";

    if (err instanceof AxiosError) {
      message =
        (err.response?.data as { error?: string })?.error ?? err.message;
    } else if (err instanceof Error) {
      message = err.message;
    }

    useToasterStore.getState().addToast({
      title: "Error",
      message,
      duration: 5000,
    });

    return undefined;
  }
};

export const putAuthEmail = async (
  payload: VerificationCodeRequest
): Promise<VerificationCodeResponse | undefined> => {
  try {
    const response = await authRefreshApi.put("/auth/email", payload);

    const answer = response.data as VerificationCodeResponse;

    return answer;
  } catch (err: unknown) {
    let message = "Unknown error";

    if (err instanceof AxiosError) {
      message =
        (err.response?.data as { error?: string })?.error ?? err.message;
    } else if (err instanceof Error) {
      message = err.message;
    }

    useToasterStore.getState().addToast({
      title: "Error",
      message,
      duration: 5000,
    });

    return undefined;
  }
};
